module.exports = __webpack_public_path__ + "static/media/0006.1c988c9a.jpg";